// src/PrivateRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";

type Props = {
  children: React.ReactNode;
};

const PrivateRoute = ({ children }: Props) => {
  const logged = localStorage.getItem("isLoggedIn");

  return logged ? <>{children}</> : <Navigate to="/" />;
};

export default PrivateRoute;
